import i18n from '@/lang';

//  时间
export const dateTime = [
  {
    label: i18n.t('Resource.DateOfRequest'),
    value: 'apply_time'
  },
  {
    label: i18n.t('receivablePayable.CompletionDate'),
    value: 'completed_time'
  }
];

// 状态
export const STATUS = {
  'PENDING': {
    label: i18n.t('receivablePayable.InReview'),
    type: 'warning',
    value: 'PENDING'
  },
  'APPROVED': {
    label: i18n.t('receivablePayable.Passed'),
    type: 'success',
    value: 'APPROVED'
  },
  'REJECTED': {
    label: i18n.t('receivablePayable.Rejected'),
    type: 'danger',
    value: 'REJECTED'
  },
  'CANCELED': {
    label: i18n.t('receivablePayable.Withdrawn'), // 撤回
    type: 'info',
    value: 'CANCELED'
  },
  'DELETED': {
    label: i18n.t('receivablePayable.Delete'),
    type: 'danger',
    value: 'DELETED'
  }
};

// 币种
export const CURRENCY = [
  {
    label: 'CNY',
    value: 'CNY'
  },
  {
    label: 'USD',
    value: 'USD'
  }
];

export const Table_Column = [
  {
    label: i18n.t('receivablePayable.ApprovalFormNumber'),
    prop: 'serialNumber',
    width: 160,
    className: 'batchNumber'
  },
  {
    label: i18n.t('basicData.status'),
    prop: 'status',
    width: 120
  },
  {
    label: i18n.t('receivablePayable.CompletionDate'),
    prop: 'completedTime',
    width: 160
  },
  {
    label: i18n.t('Resource.applicant'),
    prop: 'applicantName',
    width: 160
  },
  {
    label: i18n.t('basicData.ExpenseType'),
    prop: 'expenseType',
    width: 180
  },
  {
    label: i18n.t('receivablePayable.CostCenter'),
    prop: 'costCenter',
    width: 200
  },
  {
    label: i18n.t('receivablePayable.Region'),
    prop: 'area',
    width: 200
  },
  {
    label: i18n.t('GlobalSetObj.Estado'),
    prop: 'state',
    width: 180
  },
  {
    label: i18n.t('basicData.Outlets'),
    prop: 'station',
    width: 180
  },
  {
    label: i18n.t('receivablePayable.Currency'),
    prop: 'currency',
    width: 100
  },
  {
    label: i18n.t('receivablePayable.OriginalCurrencyAmount'),
    prop: 'amount',
    width: 100
  },
  {
    label: i18n.t('receivablePayable.BrlCurrencyAmount'),
    prop: 'brlAmount',
    width: 100
  },
  {
    label: i18n.t('Resource.DateOfRequest'),
    prop: 'applyTime',
    width: 160
  },
  {
    label: i18n.t('receivablePayable.PaymentReason'),
    prop: 'paymentPurpose',
    width: 250
  },
  {
    label: i18n.t('basicData.annex'),
    prop: 'attachmentList',
    width: 250
  }
];
